import { TFunction } from 'i18next'
import Overview from './Overview'
import Stats from './Stats'
import Customers from './Customers'
import Services from './Services'
import Invoices from './Invoices'
import { Reseller } from '../../types'

interface TabsProps {
    t: TFunction
    reseller?: Reseller
    resellerId: number
    refetch: () => void
}

export const tabs = ({ t, reseller, resellerId, refetch }: TabsProps) => [
    {
        label: t('overview'),
        value: 'overview',
        component: (
            <>
                <Overview reseller={reseller} refetch={refetch} />
                <Stats resellerId={resellerId} />
            </>
        ),
    },
    {
        label: t('customers'),
        value: 'customers',
        component: <Customers resellerId={resellerId} />,
    },
    {
        label: t('services'),
        value: 'services',
        component: <Services resellerId={resellerId} />,
    },
    {
        label: t('invoices'),
        value: 'invoices',
        component: <Invoices resellerId={resellerId} />,
    },
]
